export const SidebarData1 = {
  payroll: [
    {
      tittle: "Payroll",
      hasSubRoute: true,
      icon: "wallet",
      showSubRoute: true,
      subRoutes: [
        {
          tittle: "Dashboard",
          hasSubRoute: false,
          icon: "layout-dashboard",
          showSubRoute: false,
          route: "/payroll/dashboard",
        },
        {
          tittle: "Employee CTC",
          hasSubRoute: false,
          icon: "wallet",
          showSubRoute: false,
          route: "/payroll/employee-ctc",
        },
        {
          tittle: "Salary Advance",
          hasSubRoute: false,
          icon: "cash",
          showSubRoute: false,
          route: "/payroll/salaryadvance",
        },
        {
          tittle: "Salary List",
          hasSubRoute: false,
          icon: "list-details",
          showSubRoute: false,
          route: "/payroll/salaryList",
        },
      ],
    },
    { tittle: "Process Payroll",
       hasSubRoute: false,
        showSubRoute: false, 
          icon: "file-invoice",
        route: "/payroll/processpayroll",
         subRoutes: [],
         },
    {
      tittle: "Payslips",
      hasSubRoute: true,
      icon: "file-invoice",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Single Payslip",
          hasSubRoute: false,
          icon: "file-text",
          showSubRoute: false,
          route: "/payroll/payslip",
        },
        {
          tittle: "Last 3 Months",
          hasSubRoute: false,
          icon: "history",
          showSubRoute: false,
          route: "/payroll/last3Mpayslip",
        },
      ],
    },
    { tittle: "Expenses",
       hasSubRoute: false,
        showSubRoute: false, 
          icon: "file-invoice",
        route: "/payroll/Expenses",
         subRoutes: [],
         },
    {
      tittle: "Individual Reports",
      hasSubRoute: true,
      icon: "chart-line",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Salary Report",
          hasSubRoute: false,
          icon: "report-money",
          showSubRoute: false,
          route: "/payroll/reports/501",
        },
        {
          tittle: "PF Report",
          hasSubRoute: false,
          icon: "file-description",
          showSubRoute: false,
          route: "/payroll/reports/502",
        },
        {
          tittle: "ESI Report",
          hasSubRoute: false,
          icon: "file-analytics",
          showSubRoute: false,
          route: "/payroll/reports/503",
        },
        {
          tittle: "Bank Statement",
          hasSubRoute: false,
          icon: "building-bank",
          showSubRoute: false,
          route: "/payroll/reports/506",
        },
        {
          tittle: "Advances Report",
          hasSubRoute: false,
          icon: "credit-card",
          showSubRoute: false,
          route: "/payroll/reports/115",
        },
      ],
    },
      {
      tittle: "Group Reports",
      hasSubRoute: true,
      icon: "chart-line",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Salary Report",
          hasSubRoute: false,
          icon: "report-money",
          showSubRoute: false,
          route: "/payroll/Groupreports/501",
        },
        {
          tittle: "PF Report",
          hasSubRoute: false,
          icon: "file-description",
          showSubRoute: false,
          route: "/payroll/Groupreports/502",
        },
        {
          tittle: "ESI Report",
          hasSubRoute: false,
          icon: "file-analytics",
          showSubRoute: false,
          route: "/payroll/Groupreports/503",
        },
        {
          tittle: "Bank Statement",
          hasSubRoute: false,
          icon: "building-bank",
          showSubRoute: false,
          route: "/payroll/Groupreports/506",
        },
        {
          tittle: "Advances Report",
          hasSubRoute: false,
          icon: "credit-card",
          showSubRoute: false,
          route: "/payroll/Groupreports/115",
        },
      ],
    },
  ],
};
